<template>
  <page>
    <div>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <message :messages="messages"></message>
                <form data-vv-scope="dlGLForm">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.batchNo"
                          :label="labels.batchNo"
                          :error-messages="errors.collect('form.batchNo')"
                          data-vv-name="form.batchNo"
                          :data-vv-as="labels.batchNo"
                          :loading="loading"
                          v-validate="doValidateBatchNo"
                          @change="validateBatchNo"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.acctPeriod"
                          :label="labels.acctPeriod"
                          :error-messages="errors.collect('form.acctPeriod')"
                          data-vv-name="form.acctPeriod"
                          :data-vv-as="labels.acctPeriod"
                          :loading="loading"
                          v-validate="doValidateAcctPeriod"
                          readonly
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showAcctPeriodHelpList = true">mdi-magnify</v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <cal-picker
                          v-model="form.tranDate"
                          :label="labels.tranDate"
                          :data-vv-as="labels.tranDate"
                          :error-messages="errors.collect('form.tranDate')"
                          data-vv-name="form.tranDate"
                          :max="today"
                          v-validate="doValidateTranDate"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs12 md2>
                        <v-checkbox color="primary" :label="labels.prtCheckList" v-model="form.prtCheckList"></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-checkbox color="primary" :label="labels.postGLTran" v-model="form.postGLTran" :disabled="form.batchNo != 0"></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </form>
              </v-card-text>

              <v-card-actions>
                <v-btn color="info" dark :loading="loading" @click.prevent="doSubmit">
                  {{ labels.export }}
                  <v-icon dark right>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn-toggle dense mandatory v-model="form.format">
                  <v-btn text>
                    <span>{{ labels.format }}</span>
                    <v-icon>mdi-clipboard-text</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <v-dialog v-model="showAcctPeriodHelpList" width="1280px">
      <acct-period-help-list2
        @close="showAcctPeriodHelpList = false"
        @assign-acct-period-info="doAssign($event)"
        :boolRefresh="showAcctPeriodHelpList"
        :modeNo="modeNo"
      ></acct-period-help-list2>
    </v-dialog>

    <!-- <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Loading
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { commonMixins } from '@/mixins/common/commonMixin'
import { expandURI } from '@/utils/ajax'
import AcctPeriodHelpList2 from '@/components/core/common/dialog/AcctPeriodHelpList2'
import { formatDisplayDate, removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'

export default {
  data() {
    return {
      showBranchHelpList: false,
      showAcctNoHelpList: false,
      showDocNoHelpList: false,
      labels: {
        batchNo: 'Write records with Batch No.',
        acctPeriod: 'Accounting Period',
        tranDate: 'Transaction Date (Update to SUNGL)',
        prtCheckList: 'Print Checklist',
        postGLTran: 'Post GL Transaction',
        export: 'Export To',
        format: 'ASCII TEXT'
      },
      form: {
        batchNo: 0,
        acctPeriod: undefined,
        tranDate: new Date(),
        prtCheckList: true,
        postGLTran: false,
        format: 'PDF'
      },
      loading: false,
      modeNo: '3',
      showAcctPeriodHelpList: false,
      today: new Date(),
      validateAcctPeriodMsg: '',
      validateBatchNoMsg: ''
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('valMaxTranDate', {
      getMessage(field, args) {
        return 'Cannot be later than system date ' + formatDisplayDate(args[0])
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })

    this.$validator.extend('valBatchNo', {
      getMessage(field, args) {
        return args[0]
      },
      validate(value, args) {
        let msg = args[0]
        if (value && (msg === 'Invalid Batch No.')) {
          return false
        } else return true
      }
    })

    this.$validator.extend('valAcctPeriod', {
      getMessage(field, args) {
        return args[0]
      },
      validate(value, args) {
        let msg = args[0]
        if (value && (msg === 'No GL Transaction for this Accounting Period.' || msg === 'Invalid Accounting Period.')) {
          return false
        } else return true
      }
    })
  },
  mounted() {},
  methods: {
    async doInit() {
      this.loading = true
      await Promise.all([this.$store.dispatch('accountsInit')])
      await Promise.all([this.$store.dispatch('downloadGLTranInit')])
      this.defaultAcctPeriod()
    },
    async defaultAcctPeriod() {
      const apiURI = this.menu.defaultAcctPeriod
      if (apiURI) {
        this.loading = true
        this.$http
          .post(apiURI)
          .then(result => {
            const { data } = result
            if (data) {
              this.form.acctPeriod = data.acctPeriod
              this.loading = false
            }
          })
          .catch(err => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
            this.loading = false
          })
      }
    },
    async validateBatchNo() {
      this.resetMessages()
      this.validateBatchNoMsg = ''
      const apiURI = this.menu.validateBatchNo
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            batchNo: this.form.batchNo
          }
          const result = await this.$http.post(expandURI(apiURI, expand))
          this.form.acctPeriod = result.data.acctPeriod
          this.form.postGLTran = false
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.validateBatchNoMsg = data.fieldMessages[0].message.message
          }
          this.loading = false
        }
      }
    },
    async validateAcctPeriod() {
      this.resetMessages()
      this.validateAcctPeriodMsg = ''
      const apiURI = this.menu.validateAcctPeriod
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            acctPeriod: this.form.acctPeriod
          }
          await this.$http.post(expandURI(apiURI, expand))
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.validateAcctPeriodMsg = data.fieldMessages[0].message.message
          }
          this.loading = false
        }
      }
    },
    doAssign(data) {
      this.form.acctPeriod = data.acctPerMth + '/' + data.acctPerYr
      this.validateAcctPeriod()
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll('dlGLForm').then(result => {
        if (result) {
          this.doExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doExport() {
      const apiURI = this.menu.exportDlGLTran
      if (apiURI) {
        try {
          this.loading = true
          let messageFilters = clone(this.form)
          messageFilters.format = 'PDF'
          await this.$http.post(apiURI, messageFilters)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.specFuncAcct.downloadGLTran.menu
    },
    doValidateTranDate() {
      const maxDate = this.today
      return 'required|valMaxTranDate:' + maxDate
    },
    doValidateAcctPeriod() {
      const msgs = this.validateAcctPeriodMsg
      return 'valAcctPeriod:' + msgs
    },
    doValidateBatchNo() {
      const msgs = this.validateBatchNoMsg
      return 'valBatchNo:' + msgs
    }
  },
  watch: {
  },
  mixins: [MessageMixin, commonAjaxMixin, commonMixins],
  components: {
    AcctPeriodHelpList2
  }
}
</script>
<style lang="scss"></style>
